import { useMemo } from 'react';
import { ILookupOptionModel } from 'src/store/_models/models.types';

export const useLookupOptions = (lookupChoices: ILookupOptionModel[] = []) => {
  const isPriceVisible = useMemo(() => {
    return (
      lookupChoices.length > 1 &&
      !lookupChoices.every((lookup, index, array) => lookup.formattedPrice === array[0].formattedPrice)
    );
  }, [lookupChoices]);

  return {
    isPriceVisible,
  };
};
